import Vue from 'vue'

export default [
  {
    path: '/UnitOwnerAssembly/',
    component: () => import('@/components/Layer.vue'),
    children: [
      {
        path: '',
        name: 'UnitOwnerAssembly',
        component: () => import('@/views/UnitOwnerAssembly/AssemblyList.vue'),
        meta: {
          prev: 'goHome'
        }
      },
      {
        path: 'AssemblyEdit',
        name: 'AssemblyEdit',
        component: () => import('@/views/UnitOwnerAssembly/AssemblyEdit.vue'),
        meta: {
          prev: 'UnitOwnerAssembly'
        }
      },
      {
        path: 'AssemblyDetail/:id',
        name: 'AssemblyDetail',
        component: () => import('@/views/UnitOwnerAssembly/AssemblyDetail.vue'),
        meta: {
          prev: 'UnitOwnerAssembly'
        }
      },
      {
        path: 'AssemblyRegister/:id',
        name: 'AssemblyRegister',
        component: () => import('@/views/UnitOwnerAssembly/AssemblyRegister.vue'),
        meta: {
          prev: 'UnitOwnerAssembly'
        }
      },
      {
        path: 'UnitOwnerList/:id',
        name: 'UnitOwnerList',
        component: () => import('@/views/UnitOwnerAssembly/UnitOwnerList.vue'),
        meta: {
          prev: 'UnitOwnerAssembly'
        }
      },
      // id：會議id
      // topicId：議案id
      {
        path: ':id/TopicVoteWay/:topicId',
        name: 'TopicVoteWay',
        component: () => import('@/views/UnitOwnerAssembly/TopicVoteWay.vue'),
        meta: {
          prev: 'other' // 處理帶參數路徑，請輸入'other'，再手動更改[全域變數previousPage]改為header要跳轉上一頁的路徑
        }
      },
      {
        path: ':id/RecordNameVoting/:topicId',
        name: 'RecordNameVoting',
        component: () => import('@/views/UnitOwnerAssembly/RecordNameVoting.vue'),
        meta: {
          prev: 'other' // 處理帶參數路徑，請輸入'other'，再手動更改[全域變數previousPage]改為header要跳轉上一頁的路徑
        }
      },
      {
        path: ':id/NotRecordNameVoting/:topicId',
        name: 'NotRecordNameVoting',
        component: () => import('@/views/UnitOwnerAssembly/NotRecordNameVoting.vue'),
        meta: {
          prev: 'other' // 處理帶參數路徑，請輸入'other'，再手動更改[全域變數previousPage]改為header要跳轉上一頁的路徑
        }
      }
    ],
    beforeEnter: (to, from, next) => {
      if (!localStorage.getItem('loginUserInfo') && !JSON.parse(localStorage.getItem('loginUserInfo'))) {
        Vue.prototype.$alert('請重新登入', '警告', {
          confirmButtonText: '確定',
          type: 'warning',
          showClose: false,
          roundButton: true,
          closeOnClickModal: false
        }).then(() => {
          next({ name: 'LoginMain' })
        })
      } else {
        next()
      }
    }
  }
]
